type Registry<T> = Record<string, T>

const createRegistry = <T>() => {
	const registry: Registry<T> = {}

	const normalizeKey = (key: string) => key.toLowerCase()

	const add = (key: string, registration: T) => {
		const normalizedKey = normalizeKey(key)

		if (registry[normalizedKey]) {
			console.warn(`A registration for key ${normalizedKey} has already been registered.`)
			return
		}

		registry[normalizedKey] = registration
	}

	const get = (key: string) => {
		const normalizedKey = normalizeKey(key)

		return registry[normalizedKey] || undefined
	}

	return { add, get }
}

export default createRegistry
